<div class="form-group">
  <label class="control-label">
    <span class="form-label" *ngIf="label.length > 0">
      {{ label }}
      <span *ngIf="secondaryLabel"> - </span>
      <small>{{ secondaryLabel }}</small>
    </span>
    <ng-container *ngIf="isBoolean(value); then booleanContainer else stringContainer"></ng-container>
  </label>
</div>

<ng-template #stringContainer>
  <div class="form-control">{{ value || '-' }}</div>
</ng-template>
<ng-template #booleanContainer>
  <rx-icon
    [name]="value ? 'checkmark' : 'close'"
    [stroke]="value ? 'teal-dark': 'red-dark'"
    size="lg"
    [fill]="value ? 'none' : 'red-dark'">
  </rx-icon>
</ng-template>
